
import { Button } from "@/components/ui/button";
import { ChevronRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="py-24 md:py-32 overflow-hidden bg-gradient-to-br from-violet-50 via-white to-pink-50/40">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-12 items-center">
          <div className="md:col-span-8 lg:col-span-7 animate-fade-in">
            <h1 className="wallpaper-title text-5xl md:text-7xl lg:text-8xl mb-8">
              Määrittelemme<br/>
              Verkkokaupan<br/>
              <span className="bg-gradient-to-r from-pink-500 to-violet-500 bg-clip-text text-transparent">Tulevaisuuden</span>
            </h1>
            
            <div className="mt-10 mb-12 md:w-5/6">
              <p className="wallpaper-callout text-2xl md:text-3xl text-wallpaper-coolGray mb-0 leading-relaxed">
                "OrderSales.AI:ssa muutamme verkkokauppojen toimintaa tehokkaan tekoälyn avulla."
              </p>
            </div>
            
            <p className="font-wallpaper text-lg md:text-xl text-wallpaper-darkGray/80 mb-12 md:w-5/6 leading-relaxed">
              Tekoälypohjaiset ratkaisumme luovat intuitiivisia, personoituja ja mukaansatempaavia 
              kokemuksia, jotka määrittelevät uudelleen verkkokaupan mahdollisuudet.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Button className="wallpaper-btn bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 border-none text-base flex items-center">
                KYSY MEILTÄ
                <MessageCircle className="ml-2 h-5 w-5" />
              </Button>
              <Link to="/pitch-deck">
                <Button 
                  className="wallpaper-btn-outline w-full border-violet-400 text-violet-600 hover:bg-violet-600 hover:text-white hover:border-violet-600 text-base"
                >
                  KATSO ESITYS
                </Button>
              </Link>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
              <Link to="/product-suite">
                <Button 
                  className="wallpaper-btn-outline w-full border-pink-400 text-pink-600 hover:bg-pink-600 hover:text-white hover:border-pink-600 text-base"
                >
                  TUOTEVALIKOIMAMME
                </Button>
              </Link>
            </div>
            
            <p className="mt-16 text-sm font-wallpaper tracking-widest uppercase text-wallpaper-gray">
              Palvelemme jo 200+ verkkokauppaa 98% tyytyväisyysasteella
            </p>
          </div>
          
          <div className="md:col-span-4 lg:col-span-5 animate-fade-in">            
            <div className="mt-12 pt-12 border-t border-violet-100">
              <div className="flex flex-col space-y-8">
                <div className="flex justify-between items-center">
                  <span className="font-wallpaper text-3xl text-pink-500">01</span>
                  <span className="font-wallpaper text-sm uppercase tracking-widest">Älykäs Tekoäly</span>
                  <div className="h-px bg-pink-100 flex-grow mx-6"></div>
                  <span className="font-wallpaper text-sm text-wallpaper-gray">Verkkokauppa</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-wallpaper text-3xl text-purple-500">02</span>
                  <span className="font-wallpaper text-sm uppercase tracking-widest">Räätälöity</span>
                  <div className="h-px bg-purple-100 flex-grow mx-6"></div>
                  <span className="font-wallpaper text-sm text-wallpaper-gray">Ratkaisut</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-wallpaper text-3xl text-indigo-500">03</span>
                  <span className="font-wallpaper text-sm uppercase tracking-widest">Tulevaisuus</span>
                  <div className="h-px bg-indigo-100 flex-grow mx-6"></div>
                  <span className="font-wallpaper text-sm text-wallpaper-gray">Teknologia</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
